define('adminResTransTabs',[
  'module',
  'underscore'
], function(
  module,
  _
) {
  'use strict';

  module.exports = [
    {
      name: 'detail',
      title: _.i18n('restrans.details.tabTitle'),
      isDefault: true
    }
  ];
});
